import React from 'react'
import RecruiterDashboard from '../../Recruiter/Components/RecruiterDashboard'

export default function test() {
  return (
    <div>

      <RecruiterDashboard/>
    </div>
  )
}
